export const ckEditorConfig = {
  baseFloatZIndex: 100000,
  fullPage: true,
  toolbar: {
    items: [
      'undo',
      'redo',
      '|',
      'heading',
      '|',
      'outdent',
      'indent',
      '|',
      'fontFamily',
      'fontSize',
      'fontColor',
      'fontBackgroundColor',
      'highlight',
      'alignment',
      'removeFormat',
      '|',
      'bold',
      'italic',
      'underline',
      'strikethrough',
      // 'code',
      'subscript',
      'superscript',
      'specialCharacters',
      '|',
      'numberedList',
      'bulletedList',
      'todoList',
      // 'selectAll',
      '|',
      'outdent',
      'indent',
      '|',
      'insertTable',
      'mediaEmbed',
      'imageUpload',
      'insertImage',
      'link',
      'blockQuote',
      // 'codeBlock',
      // 'htmlEmbed',
      'horizontalLine',
      'pageBreak',
      '|',
      'sourceEditing',
      'showBlocks',
      // 'restrictedEditingException',
      // 'style',
      '|',
      // 'textPartLanguage',
      'findAndReplace',
      'accessibilityHelp',
    ],
    shouldNotGroupWhenFull: true,
  },
  language: 'ro',
  image: {
    toolbar: [
      'imageTextAlternative',
      'toggleImageCaption',
      'imageStyle:inline',
      'imageStyle:block',
      'imageStyle:side',
      'linkImage',
    ],
  },
  table: {
    contentToolbar: [
      'tableColumn',
      'tableRow',
      'mergeTableCells',
      'tableCellProperties',
      'tableProperties',
    ],
  },
  fontFamily: {
    options: [
      'Satoshi-Light',
      'Satoshi-Regular',
      'Satoshi-Medium',
      'Satoshi-Bold',
      'Satoshi-Black',
    ],
  },
  mediaEmbed: {
    previewsInData: true,
  },
  supportAllValues: true,
};
